module.exports = __webpack_public_path__ + "img/barcode.30467295.png";